import React from 'react';
import Modal from 'react-modal';
import { IntercomProvider } from 'react-use-intercom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Api } from 'services/api';
import { createQueryClient, initializePersistQueryClient } from 'utils/queryClient';
import { showVersion } from 'utils';
import { MutationKeys } from 'constants/mutationKeys';
import App from './App';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

showVersion();

Modal.setAppElement('#root');

const queryClient = createQueryClient();
Api.setQueryClient(queryClient);

initializePersistQueryClient({
  queryClient,
  excludePersistMutation: [MutationKeys.sendCode],
  storage: window.sessionStorage,
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <IntercomProvider appId={INTERCOM_APP_ID ?? ''}>
        <App />
      </IntercomProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
